import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB9_hc6UTyH3nj30Cx1t39G3iGmpeY_iPk",
  authDomain: "mediature-81135.firebaseapp.com",
  projectId: "mediature-81135",
  storageBucket: "mediature-81135.firebasestorage.app",
  messagingSenderId: "1015917114243",
  appId: "1:1015917114243:web:4cf7597b4d73c7b2cb7cb6",
  measurementId: "G-5WMGVEYBKL"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Collection pour les conflits
export const conflitsCollection = collection(db, 'conflits');

// Fonctions utilitaires
export const getConflits = async () => {
  const snapshot = await getDocs(conflitsCollection);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const addConflit = async (data) => {
  return await addDoc(conflitsCollection, data);
};

export const updateConflit = async (id, data) => {
  const conflitDoc = doc(db, 'conflits', id);
  return await updateDoc(conflitDoc, data);
};

export const deleteConflit = async (id) => {
  const conflitDoc = doc(db, 'conflits', id);
  return await deleteDoc(conflitDoc);
};

// Fonctions Storage pour les PDF (Firebase)
export const uploadPDF = async (file, folder = 'communiques', onProgress = null) => {
  const fileName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.-]/g, '_')}`;
  const storageRef = ref(storage, `${folder}/${fileName}`);
  
  try {
    if (onProgress) onProgress(50);
    
    const snapshot = await uploadBytes(storageRef, file, {
      contentType: 'application/pdf'
    });
    
    if (onProgress) onProgress(90);
    
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    if (onProgress) onProgress(100);
    
    return {
      url: downloadURL,
      path: snapshot.ref.fullPath,
      name: fileName,
      size: file.size
    };
  } catch (error) {
    console.error('Erreur upload:', error);
    if (error.code === 'storage/unauthorized') {
      throw new Error('Non autorisé. Vérifiez les règles Storage dans Firebase Console.');
    } else if (error.code === 'storage/cors-error' || error.message.includes('CORS')) {
      throw new Error('Erreur CORS. Vérifiez que Storage est activé et les règles sont publiées.');
    }
    throw error;
  }
};

export const deleteFile = async (filePath) => {
  try {
    const fileRef = ref(storage, filePath);
    await deleteObject(fileRef);
    return { success: true };
  } catch (error) {
    console.error('Erreur suppression:', error);
    throw error;
  }
};
